/**
 *  Feature Statement Event Component
 * @module patterns/components/feature-statement/event
 */

import { associateResponseWithForm } from '~/framework/utils/forms';
import { App } from '~/app';

export default (app: App) => {
    app.logger.debug('[Stockland FE] Initialise Stockland Feature Statement Event Component');

    app.afterMount
        .then(() => {
            const eventFeatures = document.querySelectorAll<HTMLElement>('.featured-content');

            if (eventFeatures) {
                for (const feature of eventFeatures) {
                    // Same as in EventCard.vue, we need to associate the form response with the singleton form

                    const modalButton = feature.querySelector<HTMLElement>('.modal-button');
                    if (!modalButton) return;

                    const selector = modalButton.dataset.bsTarget ?? '';
                    const instanceId = modalButton.dataset.instanceId ?? '';
                    const token = modalButton.dataset.token ?? '';

                    associateResponseWithForm(selector, instanceId, token);
                }
            }
        })
        .catch((error) => {
            throw new Error('[Stockland FE] Unable to register Stockland Feature Statement Event component', error);
        });
}
